<template>
  <div class="index">
    <section class="main">
      <p class="title" style="margin-bottom: 55px;">
        <el-menu
          :default-active="activeIndex"
          active-text-color="#F32735"
          class="menu"
          mode="horizontal" @select="handleSelect">
          <el-menu-item index="IDX1" class="menuItem" style="font-size: 20px;">外教口语</el-menu-item>
          <el-menu-item index="IDX2" class="menuItem" style="font-size: 20px;">对外口语</el-menu-item>
          <el-menu-item index="IDX3" class="menuItem" style="font-size: 20px;">逻辑思维</el-menu-item>
        </el-menu>
      </p>
      <section class="out">
        <div class="list">
          <img
            class="img"
            v-for="(item, index) in outList"
            :key="index"
            :src="item.posterSrc"
            @click="goLessonDetail(item)"
            alt=""
          />
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import { LESSONS_IDX1_DATA, LESSONS_IDX2_DATA, LESSONS_IDX3_DATA } from '../../utils/LingXunData'
export default {
  name: 'Index',
  data () {
    return {
      IDX1: LESSONS_IDX1_DATA,
      IDX2: LESSONS_IDX2_DATA,
      IDX3: LESSONS_IDX3_DATA,
      activeIndex: 'IDX1',
      outList: LESSONS_IDX1_DATA
    }
  },
  filters: {
    itemFilter (v) {
      return v[0].type === 'p' ? v[0].val : v[1].val
    }
  },
  mounted () {
    console.log(this.$route.query, '111111111111111')
    const { listName } = this.$route.query
    if (listName) {
      this.outList = this[listName]
      this.activeIndex = listName
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.activeIndex = key
      this.outList = this[key]
      console.log(key, keyPath, this.activeIndex, this.outList)
    },
    goLessonDetail (item) {
      localStorage.setItem('LESSON_DETAIL', JSON.stringify(item))
      this.$router.push({
        path: `/lessonDetail/${item.id}`
      })
    },
    goNewsDetail (item) {
      localStorage.setItem('NEWS_DETAIL', JSON.stringify(item))
      this.$router.push({
        path: `/newsDetail/${item.id}`
      })
    }
  }
}
</script>
<style scoped>
.title >>> .el-menu--horizontal{
  border: 0px;
  border-radius: 4px;
}
</style>
<style scoped lang="scss">
  .index{
    height: auto;
    min-height: 768px;
    width: 100%;
    margin: 0 auto;
    .title{
      height: 30px;
      font-size: 24px;
      font-weight: 600;
      color: #333;
      text-align: left;
      line-height: 30px;
      margin-bottom: 30px;
    }
    .main{
      height: auto;
      min-height: 768px;
      width: 1192px;
      margin: 0 auto;
      .out, .inner{
        height: auto;
        width: 100%;
        overflow: hidden;
        .list{
          // display: flex;
          // flex-direction: row;
          // flex-wrap: wrap;
          // align-items: center;
          // justify-content: flex-start;
          .img{
            width: 1192px;
            height: 431px;
            margin: 0 32px 32px 0;
            cursor: pointer;
            &:nth-of-type(4n){
              margin-right: 0;
            }
          }
        }
      }
      .lastestNews{
        height: auto;
        width: 100%;
        overflow: hidden;
        margin-bottom: 60px;
        .news{
          height: 78px;
          padding: 20px 0;
          width: 100%;
          border-bottom: 1px solid #eee;
          cursor: pointer;
          .up{
            height: 40px;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .sub{
              font-size: 16px;
              color: #333;
              font-weight: 500;
            }
            .time{
              font-size: 14px;
              color: #999;
            }
          }
          .down{
            height: 38px;
            width: 100%;
            font-size: 14px;
            color: #999;
            text-align: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
  }
</style>
